import type { ReactNode } from "react";

interface ScreenLoadingProps {
  label: ReactNode;
  background?: string;
}

interface ScreenErrorProps {
  title: ReactNode;
  detail: ReactNode;
  background?: string;
}

interface EmptyStateProps {
  children: ReactNode;
  padding?: string;
  paddingBottom?: string;
}

export function ScreenLoading({ label, background = "var(--color-fullscreen-surface)" }: ScreenLoadingProps) {
  return (
    <div
      className="flex h-screen w-screen items-center justify-center text-white"
      style={{ background }}
    >
      {label}
    </div>
  );
}

export function ScreenError({ title, detail, background = "var(--color-fullscreen-surface)" }: ScreenErrorProps) {
  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center gap-xl text-white"
      style={{ background }}
    >
      <div>{title}</div>
      <div className="text-[12px] text-white-alpha-70">
        {detail}
      </div>
    </div>
  );
}

export function EmptyState({ children, padding = "40px 20px", paddingBottom }: EmptyStateProps) {
  return (
    <div
      className="text-center text-white-alpha-70"
      style={{
        padding,
        ...(paddingBottom ? { paddingBottom } : {}),
      }}
    >
      {children}
    </div>
  );
}
